module.exports = __webpack_public_path__ + "img/90.67a667a1.jpg";